<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div
        v-if="modelValue"
        class="modal-overlay"
        @click.self="close"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
      >
        <div class="modal-panel">
          <div class="modal-header">
            <slot name="header">
              <span class="modal-title" :id="titleId">
                <span class="material-symbols-outlined" style="font-size:18px;vertical-align:middle;margin-right:6px">help</span>
                {{ title }}
              </span>
            </slot>
            <button class="modal-close" @click="close" aria-label="Cerrar" type="button">
              <span class="material-symbols-outlined">close</span>
            </button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modelValue: Boolean,
    title: {
      type: String,
      default: "Ayuda",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    titleId() {
      return "modal-title-" + Math.random().toString(36).slice(2, 7);
    },
  },
  watch: {
    modelValue(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
    document.body.style.overflow = "";
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    },
    handleKeydown(e) {
      if (e.key === "Escape" && this.modelValue) this.close();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 1rem;
}

.modal-panel {
  background: #ffffff;
  border-radius: 14px;
  width: 100%;
  max-width: 1200px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: #003d99;
  flex-shrink: 0;
}

.modal-title {
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
}

.modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  padding: 4px;
  transition: background 0.2s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.28);
}

.modal-close .material-symbols-outlined {
  font-size: 20px;
}

.modal-body {
  overflow-y: auto;
  padding: 1.5rem;
  flex: 1;
}

/* Transición */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-active .modal-panel,
.modal-fade-leave-active .modal-panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-from .modal-panel,
.modal-fade-leave-to .modal-panel {
  transform: translateY(-16px);
  opacity: 0;
}
</style>